export const selectRecordingCutsIsShowing = ({ recordingCuts }) =>
  recordingCuts.isCutsPageShowing;

export const selectRecordingCutIds = ({ recordingCuts }) =>
  recordingCuts.cutIds;

export const selectRecordingCutsFetchingState = ({
  recordingCuts: { isDone, isError, isLoading },
}) => ({ isDone, isError, isLoading });
